import {useSelector} from 'react-redux';

const selectRedesign = (state) => state.feedbackReducer?.redesign || {};

export const useFeedbackSummary = () =>
  useSelector((state) => selectRedesign(state).summary);
export const useFeedbackSummaryLoading = () =>
  useSelector((state) => !!selectRedesign(state).summaryLoading);

export const useFeedbackReviews = () =>
  useSelector((state) => selectRedesign(state).reviews || []);
export const useFeedbackReviewsLoading = () =>
  useSelector((state) => !!selectRedesign(state).reviewsLoading);
export const useFeedbackReviewsTotalCount = () =>
  useSelector((state) => selectRedesign(state).reviewsTotalCount || 0);
export const useFeedbackReviewsHasNextPage = () =>
  useSelector((state) => !!selectRedesign(state).reviewsHasNextPage);
export const useFeedbackReviewsPage = () =>
  useSelector((state) => selectRedesign(state).reviewsPage || 0);

export const useFeedbackReviewContext = (reviewId) =>
  useSelector((state) =>
    reviewId ? selectRedesign(state).contextById?.[reviewId] : undefined
  );
export const useFeedbackReviewContextLoading = (reviewId) =>
  useSelector((state) =>
    reviewId ? !!selectRedesign(state).contextLoadingById?.[reviewId] : false
  );

export const useFeedbackContactStatusUpdating = (reviewId) =>
  useSelector((state) =>
    reviewId
      ? !!selectRedesign(state).contactStatusUpdatingById?.[reviewId]
      : false
  );

export const useFeedbackReplySending = (reviewId) =>
  useSelector((state) =>
    reviewId ? !!selectRedesign(state).replySendingById?.[reviewId] : false
  );
export const useFeedbackReplySent = (reviewId) =>
  useSelector((state) =>
    reviewId ? selectRedesign(state).replySentById?.[reviewId] : undefined
  );

export const useFeedbackDiscount = () =>
  useSelector((state) => selectRedesign(state).feedbackDiscount);
export const useFeedbackDiscountLoading = () =>
  useSelector((state) => !!selectRedesign(state).feedbackDiscountLoading);
export const useFeedbackDiscountSaving = () =>
  useSelector((state) => !!selectRedesign(state).feedbackDiscountSaving);
